<template>
  <div class="edit-chart" v-if="isLoaded">
    <div class="audit-edit-chart__header">
      {{$t('feed.audit.edit.caption')}}
    </div>

    <component :is="chartTable" :data="data" :chart-name="chartName"></component>
  </div>
</template>

<script>
  /*edit chart component for audit charts*/

  //components
  import Views from "./table/ViewsTable";
  import Involvement from "./table/InvolvementTable";
  import Sex from "./table/SexTable";
  import Age from "./table/AgeTable";
  import SummaryLikesAndReposts from "./table/SummaryTable";

  export default {
    name: "EditChart",
    props: {
      chartName: {
        type: String
      }
    },
    computed: {
      chartTable() {
        return  this.chartName;
      },
      isLoaded() {
        return this.$store.getters.isAuditLoaded(this.chartName);
      },
      data() {
        return this.$store.getters.auditData(this.chartName);
      },
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    },
    components: {
      Views,
      Involvement,
      Sex,
      Age,
      SummaryLikesAndReposts
    }
  };
</script>

<style>
  .audit-edit-chart__header {
    margin-bottom: 55px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: #000000;
  }
</style>
